var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-option",class:{border:_vm.border,active:_vm.active}},[_c('div',{staticClass:"checkbox"}),_vm._v(" "),_c('div',{staticClass:"option-name",domProps:{"innerHTML":_vm._s(_vm.desc)}})])}
var staticRenderFns = []

export { render, staticRenderFns }